import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import React, { useState } from "react";
import { IAddValueDialogProps } from "../../interfaces";

export const AddValueDialog: React.FC<IAddValueDialogProps> = ({
    open,
    handleClose,
    ...props
}: IAddValueDialogProps) => {


    const [valueName, setValueName] = useState("");


    return <Dialog
        open={open}
        onClose={() => handleClose()}
    >
        <DialogTitle>Enter a New Value</DialogTitle>
        <DialogContent>

            <TextField
                sx={{mt:1} }
                label="Value"
                value={valueName}
                onChange={(e) => { setValueName(e.target.value) }}
            />

        </DialogContent>

        <DialogActions>
            <Button color="warning" onClick={() => handleClose()}>Cancel</Button>
            <Button
                color="primary"
                onClick={() => handleClose(valueName)}
                disabled={valueName.length < 1}
            >Add</Button>
        </DialogActions>
    </Dialog>
}